"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const lodash_1 = __importDefault(require("lodash"));
function appBatchToApiBatch(params) {
    const { orderBatch, deliveryType, payment, shipping, takeawayInfo = {}, ignoreUnavailable = false, needTableware, lastSubOrder, promoCode, riceCoin, from, } = params;
    const data = {
        batchID: orderBatch.id,
        items: toBatchRequestItems(orderBatch.items, from),
        remark: orderBatch.remark,
        ignoreUnavailable: ignoreUnavailable,
        takeout: orderBatch.takeout,
        deliveryType: deliveryType,
        payment: payment,
        shipping: shipping,
        needTableware: needTableware !== null && needTableware !== void 0 ? needTableware : deliveryType !== 'table',
        takeawayInfo: takeawayInfo,
        promoCode: promoCode,
        riceCoin: riceCoin,
        from,
    };
    if (deliveryType === 'storeDelivery') {
        data.takeawayInfo = takeawayInfo;
    }
    if (lastSubOrder != null) {
        data.lastSubOrder = lastSubOrder;
    }
    return data;
}
exports.default = appBatchToApiBatch;
function toBatchRequestItems(batchItems, from = 'MERCHANT') {
    const formatedItems = [];
    // 全部 batch 共用 index，所以要重新編排 setMenuIndex
    // 原本的 setMenuIndex 會加上這個 setIndex
    let setIndex = 0;
    batchItems.forEach(batchItem => {
        const isSet = batchItem.setItems != null && batchItem.setItems.length > 0;
        const mainBatchItem = {
            menuID: batchItem.menuId,
            setID: batchItem.setId != null ? batchItem.setId : undefined,
            setMenuID: batchItem.setMenuId != null ? batchItem.setMenuId : null,
            setMenuIndex: null,
            setName: isSet ? batchItem.name : undefined,
            name: batchItem.name,
            desc: batchItem.desc != null ? batchItem.desc : '',
            price: batchItem.price,
            discount: batchItem.discount,
            modifiers: batchItem.modifiers,
            divisor: batchItem.divisor,
            options: batchItem.options.map(option => {
                return {
                    optionID: option.optionItemId,
                    name: option.name,
                    price: option.price,
                    quantity: option.quantity,
                };
            }),
            tags: batchItem.tags,
            remarks: batchItem.remarks,
            isSet: false,
        };
        if (isSet) {
            // 套餐
            // merchant
            if (from === 'MERCHANT') {
                // 重新設定 setMenuIndex (setItem is read only, so use produce)
                const setItems = immer_1.produce(batchItem.setItems, (setItems) => {
                    setItems.forEach(setItem => {
                        if (setItem.setMenuIndex === null) {
                            // 未分組的 setMenuItemIndex 設為 0
                            setItem.setMenuIndex = 0 + setIndex;
                        }
                        else {
                            setItem.setMenuIndex += setIndex;
                        }
                    });
                });
                const setGroups = lodash_1.default.groupBy(setItems, 'setMenuIndex');
                // 加入 setItems with same setMenuIndex
                lodash_1.default.forEach(setGroups, (setGroupItems, setMenuIndex) => {
                    // 加入相同 setMenuIndex 的 main item
                    formatedItems.push(Object.assign(Object.assign({}, mainBatchItem), { setMenuIndex: Number(setMenuIndex), isSet: true }));
                    setGroupItems.forEach(setItem => {
                        const setBatchItem = {
                            menuID: setItem.menuId,
                            setMenuID: setItem.setMenuId,
                            setMenuIndex: Number(setMenuIndex),
                            setName: mainBatchItem.setName,
                            name: setItem.name,
                            desc: setItem.desc != null ? setItem.desc : '',
                            price: setItem.price,
                            discount: setItem.discount,
                            modifiers: setItem.modifiers,
                            options: setItem.options.map(option => {
                                return {
                                    optionID: option.optionItemId,
                                    name: option.name,
                                    price: option.price,
                                    quantity: option.quantity,
                                };
                            }),
                            tags: setItem.tags,
                            remarks: setItem.remarks,
                            isSet: false,
                        };
                        lodash_1.default.times(batchItem.quantity, () => {
                            // 有幾個 quantity 就要 push 幾次
                            formatedItems.push(setBatchItem);
                        });
                    });
                });
            }
            else {
                // customer 的套餐，不管數量有幾個內容都長一樣
                lodash_1.default.times(batchItem.quantity, (i) => {
                    const setMenuIndex = setIndex + i;
                    // 加入 mainItem
                    formatedItems.push(Object.assign(Object.assign({}, mainBatchItem), { setMenuIndex: Number(setMenuIndex), isSet: true }));
                    // 加入 setItems
                    batchItem.setItems.forEach((setItem) => {
                        const setBatchItem = {
                            menuID: setItem.menuId,
                            setMenuID: setItem.setMenuId,
                            setMenuIndex: Number(setMenuIndex),
                            setName: mainBatchItem.setName,
                            name: setItem.name,
                            desc: setItem.desc != null ? setItem.desc : '',
                            price: setItem.price,
                            discount: setItem.discount,
                            modifiers: setItem.modifiers,
                            options: setItem.options.map(option => {
                                return {
                                    optionID: option.optionItemId,
                                    name: option.name,
                                    price: option.price,
                                    quantity: option.quantity,
                                };
                            }),
                            tags: setItem.tags,
                            remarks: setItem.remarks,
                            isSet: false,
                        };
                        lodash_1.default.times(setItem.quantity, () => {
                            // 有幾個 quantity 就要 push 幾次
                            formatedItems.push(setBatchItem);
                        });
                    });
                });
            }
            // 有幾個 quantity 就會用掉幾個 setIndex
            setIndex += batchItem.quantity;
        }
        else {
            // 單點，有幾個 quantity 就 push 幾次
            lodash_1.default.times(batchItem.quantity, () => {
                formatedItems.push(mainBatchItem);
            });
        }
    });
    return formatedItems;
}
//# sourceMappingURL=appBatchToApiBatch.js.map